import { DefaultState } from 'store/types';

export const EDIT_GUEST_REQUEST = 'EDIT_GUEST_REQUEST';
export const EDIT_GUEST_SUCCESS = 'EDIT_GUEST_SUCCESS';
export const EDIT_GUEST_FAILURE = 'EDIT_GUEST_FAILURE';

export interface EditGuestParams {
  id: string;
  firstName: string;
  lastName: string;
  gender: string;
  email: string;
  phoneNumber: string;
}

export type EditGuestState = DefaultState;

interface EditGuestRequest {
  type: typeof EDIT_GUEST_REQUEST;
}

interface EditGuestSuccess {
  type: typeof EDIT_GUEST_SUCCESS;
}

interface EditGuestFailure {
  type: typeof EDIT_GUEST_FAILURE;
}

export type EditGuestActionTypes = EditGuestRequest | EditGuestSuccess | EditGuestFailure;
